document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".backend-by-experts-card");
  const carousel = document.querySelector(".backend-by-experts__carousel");
  
  const progressBar = document.querySelector(".backend-by-experts__progress-bar");
   const MIN_PROGRESS = 10;
 
  /* =====================================
     PROGRESS BAR (SCROLL BASED)
     ===================================== */

  function updateProgressBar() {
    const scrollLeft = carousel.scrollLeft;
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;

    if (maxScroll <= 0) {
      progressBar.style.width = "100%";
      return;
    }

    const scrollProgress = (scrollLeft / maxScroll) * (100 - MIN_PROGRESS);
    const progress = MIN_PROGRESS + scrollProgress;

    progressBar.style.width = `${progress}%`;
  }

  carousel.addEventListener("scroll", updateProgressBar);
  updateProgressBar();

 

  /* =====================================
     DRAGGABLE / SWIPE CAROUSEL
     ===================================== */

  let isDown = false;
  let startX;
  let scrollLeft;

  // MOUSE DRAG
  carousel.addEventListener("mousedown", (e) => {
    isDown = true;
    carousel.classList.add("is-dragging");
    startX = e.pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
  });

  carousel.addEventListener("mouseleave", () => {
    isDown = false;
    carousel.classList.remove("is-dragging");
  });

  carousel.addEventListener("mouseup", () => {
    isDown = false;
    carousel.classList.remove("is-dragging");
  });

  carousel.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - carousel.offsetLeft;
    const walk = (x - startX) * 1.5;
    carousel.scrollLeft = scrollLeft - walk;
  });

  // TOUCH DRAG
  let startTouchX = 0;

  carousel.addEventListener("touchstart", (e) => {
    startTouchX = e.touches[0].clientX;
    scrollLeft = carousel.scrollLeft;
  });

  carousel.addEventListener("touchmove", (e) => {
    const x = e.touches[0].clientX;
    const walk = (x - startTouchX) * 1.3;
    carousel.scrollLeft = scrollLeft - walk;
  });
});





